<button class="btn btn-danger btn-block w-100" type="button">{{ label }}</button>
